import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Department from "../components/buttons/Department";
import GoogleTranslateBar from "../components/GoogleTranslateBar";
import ContactInfo from "../components/ContactInfo";
import EmergencyContact from "../components/EmergencyContact";
import ContactUsForm from "../components/ContactUsForm";
import "../assets/styles/layout/navbar.css";
import logo from "../assets/img/logos/kentucky-icons/Team-Kentucky_CHFS-Branding_blue_50.png";
import crisisNumber from "../assets/img/logos/988/988-horizontal-white-black.jpg";
import data from "../data/data.json";

function Navbar(props) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchInput, setSearchInput] = useState("");

  const toggleDropdown = (menuName) => {
    setOpenDropdown(openDropdown === menuName ? null : menuName);
  };

  useEffect(() => {
    const handleGlobalKeys = (e) => {
      if (e.key === "Escape") setOpenDropdown(null);
    };

    document.addEventListener("keydown", handleGlobalKeys);
    return () => document.removeEventListener("keydown", handleGlobalKeys);
  }, []);

  const handleChange = (e) => setSearchInput(e.target.value);
  const handleKeyDown = (e) =>
    e.key === "Enter" &&
    window.open("//://google.com_" + searchInput, "_blank");

  const searchForService = () => {
    window.open(
      "//" + "www.google.com/search?q=ky_dbhdid_" + searchInput,
      "_blank",
    );
  };

  return (
    <>
      {/* 1. Skip Link (Final hurdle for 100% compliance) */}
      <a href="#main-content" className="sr-only sr-only-focusable">
        Skip to main content
      </a>

      <header aria-label="DBHDID Site Header" className="bottom-nav">
        {/* 2. Top Info Bar */}
        <nav aria-label="Crisis Information" className="navbar-text-info">
          <div className="container-fluid d-flex flex-column flex-md-row justify-content-between align-items-center">
            {/* Left Side: 988 Info */}
            <div className="d-flex align-items-center mb-2 mb-md-0">
              <a href="https://samhsa.gov">
                <img
                  src={crisisNumber}
                  alt="988 Suicide and Crisis Lifeline"
                  style={{ width: "120px" }}
                />
              </a>
              <strong className="ms-2">
                In Crisis? <a href="tel:988">Call</a> or{" "}
                <a href="sms:988">Text</a> 988
              </strong>
            </div>

            {/* Right Side: Google Translate */}
            <div
              role="region"
              aria-label="Language"
              className="google-widget-translate"
            >
              <GoogleTranslateBar />
            </div>
          </div>
        </nav>
        <hr className="my-0 border-secondary opacity-25" />

        {/* 3. Branding Bar (FIXES OVERLAP) */}
        <div className="bg-white border-bottom">
          <div className="container d-flex justify-content-between align-items-center py-3">
            <div className="d-lg-none" style={{ width: "40px" }}></div>
            <Link to="/" className="navbar-brand m-0 mx-lg-0 mx-auto">
              <img
                src={logo}
                alt="Team Kentucky Logo"
                className="dbhdid-logo"
                style={{ width: "120px" }}
              />
            </Link>

            <div className="d-flex align-items-center gap-3">
              {/* Accessible Search */}
              <div className="search-container d-none d-md-block">
                <label htmlFor="nav-search-mobile" className="sr-only">
                  Search services
                </label>
                <form
                  className="container d-flex searchbar"
                  onSubmit={(e) => {
                    e.preventDefault();
                    searchForService();
                  }}
                >
                  <input
                    id="nav-search-mobile"
                    type="search"
                    className="form-control"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <button className="btn btn-primary ms-2" title="Search" type="submit">
                    Search
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* 4. Main Navigation Menu */}
        <nav
          aria-label="Main Menu"
          className="navbar navbar-expand-lg navbar-dark department-nav"
        >
          <div className="container">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
              aria-expanded="false"
              aria-label="Toggle menu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="mainNav">
              <ul className="navbar-nav mx-auto">
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle font-custom"
                    id="divDrop"
                    type="button"
                    onClick={() => toggleDropdown("divisions")}
                    aria-expanded={openDropdown === "divisions"}
                  >
                    Divisions
                  </button>
                  {openDropdown === "divisions" && (
                    <ul className="dropdown-menu show" aria-labelledby="divDrop">
                      {data.departmentNames.map((item, i) => (
                        <Department
                          key={i}
                          path={item.path}
                          department={item.title}
                        />
                      ))}
                    </ul>
                  )}
                </li>
                <li className=" nav-item  dropdown">
                  <button
                    className="nav-link center-nav-tabs dropdown-toggle font-custom"
                    title="Reports"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded={openDropdown === "reports"}
                  >
                    Reports
                  </button>
                  <ul
                    className="dropdown-menu "
                    aria-labelledby="navbarDropdown"
                  >
                    {data.cmhc.map((data, index) => {
                      return (
                        <Department
                          key={index}
                          path={data.path}
                          department={data.title}
                        />
                      );
                    })}
                  </ul>
                </li>
                <li className=" nav-item  dropdown">
                  <button
                    className="nav-link center-nav-tabs dropdown-toggle font-custom"
                    title="Facilities"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    Facilities
                  </button>
                  <ul
                    className="dropdown-menu "
                    aria-labelledby="navbarDropdown"
                  >
                    {data.facilities.map((data, index) => {
                      return (
                        <Department
                          key={index}
                          path={data.path}
                          department={data.title}
                        />
                      );
                    })}
                  </ul>
                </li>
                <li className=" nav-item  dropdown">
                  <button
                    className="nav-link center-nav-tabs dropdown-toggle font-custom"
                    title="Community Mental Health Centers"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    CMHC
                  </button>
                  <ul
                    className="dropdown-menu "
                    aria-labelledby="navbarDropdown"
                  >
                    {data.reports.map((data, index) => {
                      return (
                        <Department
                          key={index}
                          path={data.path}
                          department={data.title}
                        />
                      );
                    })}
                  </ul>
                </li>
                <li className=" nav-item  center-nav-tabs">
                  <a
                    className="nav-link  font-custom"
                    title="Calendar of Events"
                    aria-current="page"
                    href="/calendar"
                  >
                    Calendar
                  </a>
                </li>
                <li className=" nav-item center-nav-tabs">
                  {/* <a className="nav-link  font-custom" aria-current="page" href="/providerdirectory">Provider Directory</a> */}
                  <a
                    className="nav-link  font-custom"
                    title="Provider Directory"
                    aria-current="page"
                    href="/providerdirectory"
                  >
                    Provider Directory
                  </a>
                </li>
                <li className="  nav-item  dropdown dropdown-width">
                  <button
                    className=" nav-link center-nav-tabs dropdown-toggle font-custom "
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    Contact Us
                  </button>
                  <ul
                    className="  dropdown-menu dropdown-width "
                    aria-labelledby="navbarDropdown "
                  >
                    {/* <ContactInfo pageID={props.iD} /> */}
                    <EmergencyContact />
                    {/* <div className="contact-us-tab-space">
                      <ContactUsForm />
                    </div> */}
                  </ul>
                </li>

                <div className="d-lg-none py-3">
                  <form
                    className="d-flex searchbar"
                    onSubmit={(e) => {
                      e.preventDefault();
                      searchForService();
                    }}
                  >
                    <input
                      id="nav-search-mobile-two"
                      type="search"
                      className="form-control"
                      placeholder="Search..."
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                    <button
                      className="btn btn-primary ms-2"
                      // onClick={searchForService}
                      type="submit"
                    >
                      Search
                    </button>
                  </form>
                </div>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <main id="main-content" tabIndex="-1"></main>
    </>
  );
}

export default Navbar;
